<template>
  <div class="bind-container">
    <!-- <input type="number" maxlength="11" class="phone-input" placeholder="输入您的手机号" v-model="phone">
    <div class="code-wrapper">
      <input type="number" class="code-input" placeholder="输入验证码" v-model="code">
      <div v-if="!timerText" class="send-code" @click="sendCode">获取验证码</div>
      <div v-else class="send-code disabled">{{timerText}}</div>
    </div>
    <div class="bind-phone" @click="bindPhone">绑定手机号</div>
    <p class="text">授权代表您同意<span>《国花瓷西凤酒消费者服务协议》</span></p>
    <div class="logo-text">
      <p>广州树云科技有限公司</p>
      <p>提供技术支持</p>
    </div> -->

    <Overlay :Show="showBind">
      <div class="user-container-dialog">
        <div class="user-container-dialog__title">
          <div class="">温馨提示</div>
          <!-- <img src="../../assets/img/icon_close.png" alt="" @click="close"> -->
        </div>
        <div class="user-container-dialog__content">为确认您的消费者身份，请填输入手机号获取验证码，手
          机号验证通过后，可以参与营销活动</div>


        <NormalInput class="user-container-dialog__inp" v-model="phone" keyname="phone" clearable placeholder="输入您的手机号"
          label="" :maxlength="11" :rules="mobileRules" @input="inputUpdate" @dropDownValueChange="fruitValueChange">
        </NormalInput>

        <!-- <div class="user-container-dialog__phone">
          <input v-model="phone" type="number" maxlength="11" placeholder="输入您的手机号" />
        </div> -->
        <div class="user-container-dialog__btn">
          <button :disabled="!phoneVerify" :style="phoneVerify ? '' : 'background: #f8dda1;'"  @click="sendCode()">继续</button>
        </div>
      </div>
    </Overlay>
    <Overlay :Show="showCode">
      <div class="user-container-dialog">
        <div class="user-container-dialog__title">
          <div class="">输入验证码</div>
          <img src="../../assets/img/icon_close.png" alt="" @click="close">
        </div>
        <div class="user-container-dialog__content">我们刚向您的手机 <span style="color: #FAC859">{{ phone.substring(0,
          3) + '****' + phone.substring(7)
            }}</span>发送了验证码</div>
        <CodeInput :size="4" @input="codeInput"></CodeInput>
        <div class="user-container-dialog__btn">
          <button @click="bindPhone()">验证</button>
        </div>
      </div>
    </Overlay>
  </div>
</template>
<script>
import Vue from 'vue'
import qs from 'qs'
import { Toast } from 'vant'
import { mapGetters } from 'vuex'
import Overlay from '@/components/overlay.vue';
import CodeInput from '@/components/code-input.vue';
import NormalInput from '@/components/normalInput.vue'
Vue.use(Toast)

export default {
  name: 'PhoneBind',
  data() {
    return {
      phone: '',
      code: '',
      timerText: '',
      phoneVerify: false,
      showBind: true,
      showCode: false,
      mobileRules: [{ type: 'isPhoneNumber', message: '手机号格式不对' }],
    }
  },
  created() {
  },
  computed: {
    ...mapGetters(['userInfo', 'qrcode'])
  },
  components: {
    Overlay,
    CodeInput,
    NormalInput
  },
  methods: {
    showBindChang() {
      this.showBind = true
    },
    close() {
      this.showBind = false
      this.showCode = false
    },
    fruitValueChange(e, keyname) {
      console.log(e, keyname)
      this[keyname + 'Verify'] = e
    },
    inputUpdate(e) {
      console.log(e, '---')
    },
    codeInput(newCode) {
      console.log(newCode)
      this.code = newCode
    },
    sendCode() {
      if (!this.phone || !(/^1[3456789]\d{9}$/.test(this.phone))) {
        return Toast('请输入正确的手机号')
      }
      var that = this
      var params = { mobile: this.phone, type: 1 }
      this.axios.post('/system/sms/verify_mobile/', qs.stringify(params)).then(function(res) {
        if (res.code === 0) {
          that.showBind = false
          that.showCode = true
          console.log(res.code)
          Toast('发送成功')
          that.timerText = '60s后重新发送'
          let total = 60
          var clock = window.setInterval(() => {
            total--
            that.timerText = total + 's后重新发送'
            if (!total) {
              total = 60
              that.timerText = ''
              clearInterval(clock)
            }
          }, 1000)
        } else {
          Toast(res.msg)
        }
      }).catch(function(error) {
        console.log(error)
        Toast('发送失败')
      })
    },
    bindPhone() {
      if (!this.phone) {
        return Toast('请输入手机号')
      }
      if (!this.code) {
        return Toast('请输入验证码')
      }
      var that = this
      var params = { mobile: this.phone, code: this.code }
      this.axios.post('/user/bind_mobile/', qs.stringify(params)).then(function(res) {
        console.log(res.data)
        if (!res.code) {
          Toast('绑定成功')
          that.$store.dispatch('setPhone', that.phone)
          if (that.qrcode.activity_url) {
            var path = that.qrcode.activity_url
            // var path = '/award'
            console.log(1)
            that.$router.push({ path: path, query: { serial: that.$route.query.serial }})
          } else {
            console.log(2)
            that.$router.push({ path: 'Index' })
          }
          that.showCode = false
          that.showBind = true
        } else {
          that.showCode = false
          that.showBind = true
          Toast(res.msg)
        }
      }).catch(function(error) {
        that.showCode = false
        that.showBind = true
        console.log(error)
        Toast('绑定失败')
      })
    }
  }
}
</script>

<style lang="scss" scoped>

/deep/ .login-input {
    font-size: 14px !important;
    color: #111827 !important;
    background: #F6F8FA !important;
    border-radius: 12px;
    z-index: 0;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    border: none !important;

    input {
      background-color: transparent !important;
    }
  }
  
  .user-container {
  .person-wrapper {
    height: 80px;
    padding: 0 15px;
    margin-bottom: 10px;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    position: relative;

    .avatar {
      width: 60px;
      height: 60px;
      border-radius: 30px;
    }

    .name-wrapper {
      margin-left: 20px;

      p {
        color: #4a4a4a;
        font-size: 14px;
        font-weight: 600;
        line-height: 20px;
      }

      span {
        color: #747474;
        font-size: 12px;
        font-weight: 400;
        line-height: 20px;
      }
    }

    .arrow {
      width: 6px;
      height: 10px;
      position: absolute;
      right: 20px;
    }
  }

  .user-item:nth-child(4) {
    margin-bottom: 10px;
  }

  .user-item {
    height: 44px;
    padding: 0 20px;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 1px;

    p {
      color: #000000;
      font-size: 14px;
      font-weight: 400;
    }

    .user-detail {
      span {
        color: #747474;
        font-size: 14px;
        font-weight: 400;
        margin-right: 10px;
      }

      img {
        width: 6px;
        height: 10px;
      }
    }
  }

  .logo-text {
    width: 100%;
    position: fixed;
    bottom: 20px;
    text-align: center;

    p {
      color: #aaaaaa;
      font-size: 10px;
      font-weight: 400;
    }
  }


  &-dialog {
    background: #FFFFFF;
    border-radius: 16px;
    margin-left: 20px;
    margin-right: 20px;
    padding: 20px;


    &__title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #111827;
      line-height: 22px;
      text-align: left;
      font-style: normal;
      text-transform: none;

      img {
        width: 25px;
        height: 25px;
      }
    }

    &__content {
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      margin-top: 20px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #A0AEC0;
      line-height: 17px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-bottom: 10px;
    }

    &__btn {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      padding-top: 15px;
      padding-bottom: 15px;
      button {
        width: 100%;
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 15px;
        padding-bottom: 15px;
        background: #FAC859;
        box-shadow: 0px 4px 8px 0px rgba(250, 200, 89, 0.11);
        border-radius: 12px;
        font-weight: 500;
        font-size: 16px;
        color: #FFFFFF;
        border-style: none;
        font-style: normal;
      }
    }

    &__inp {
      margin-top: 24px;
    }

    &__phone {
      margin-top: 25px;
      background: #F6F8FA;
      border-radius: 12px;

      input {
        padding: 15px;
      }

    }
  }


}

.bind-container{
  padding-top: 20px;
  .phone-input{
    width: 322px;
    height: 50px;
    margin: 0 auto 15px;
    padding-left: 15px;
    display: block;
    border-radius: 5px;
    // border: 1px solid #dddddd;
    background-color: #ffffff;
  }
  .code-wrapper{
    display: flex;
    align-items: center;
    .code-input{
      width: 178px;
      height: 50px;
      margin-left: 19px;
      padding-left: 15px;
      border-radius: 5px;
      // border: 1px solid #dddddd;
      background-color: #ffffff;
    }
    .send-code{
      width: 136px;
      height: 50px;
      border-radius: 5px;
      background-color: #5e5ef6;
      color: #ffffff;
      font-size: 14px;
      font-weight: 600;
      line-height: 50px;
      text-align: center;
      margin-left: 6px;
    }
    .disabled{
      background-color: #848484;
    }
  }
  .bind-phone{
    width: 337px;
    height: 45px;
    margin: 20px auto;
    border-radius: 5px;
    background-color: #5e5ef6;
    color: #ffffff;
    font-size: 16px;
    font-weight: 600;
    line-height: 45px;
    text-align: center;
  }
  .text{
    color: #4a4a4a;
    font-size: 12px;
    font-weight: 400;
    margin: 15px 0 0 19px;
    span{
      color: #8ac0ff;
      font-size: 12px;
      font-weight: 400;
    }
  }
  .logo-text{
    width: 100%;
    position: fixed;
    bottom: 20px;
    text-align: center;
    p{
      color: #aaaaaa;
      font-size: 10px;
      font-weight: 400;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/phoneBind.vue